export const i18nKeyPrefix = 'MAIN-SCHOOL'
